import { ChangeTracker } from './ChangeTracker';
import { DomainStore } from './DomainStore';

export interface DomainContext {
    readonly tracker: ChangeTracker;
    readonly store: DomainStore;
}

export function createDomainContext(): DomainContext {
    const store = new DomainStore();
    const tracker = new ChangeTracker((changeset) => store.notify(changeset));
    return { tracker, store };
}
